<template>
  <span @click="addClientNote">+ pridať</span>
</template>

<script>
export default {
  name: "ClientNoteHandler",
  props: {
    client: Object
  },
  methods: {
    addClientNote() {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: {client: this.client},
        component: "ClientNotePopUp",
        rules: ['single'],
      })
    }
  }
}
</script>

<style scoped>

</style>